import { Injectable, OnInit } from "@angular/core";

@Injectable({ providedIn: "root" })
export class StatusTranslatorService {

  statuses: Map<string, string>;

  constructor() {
    this.statuses = new Map<string, string>();
    this.statuses.set("AWAITING_DOZ_DISTRIBUTION", "Очікує рішення");
    this.statuses.set("DRAFT", "Чернетка");
    this.statuses.set("PENDING_APPROVAL", "На погодженні");
    this.statuses.set("COMPLETED", "Виконано");
    this.statuses.set("ARCHIVED", "Архівовано");
    this.statuses.set("PARTIALLY_APPROVED", "Часткове підтвердження");
    this.statuses.set("REJECTED", "Відхилено");
    this.statuses.set("SIGNED", "Підписано");
  }

  getStatusForString(text: string): string {
    return this.statuses.get(text) || text;
  }
  getStatuses(): any {
    let retVal: any[] = []
    this.statuses.forEach((value: string, key: string) => {
      retVal.push({ label: value, value: key });
    });
    return retVal;
  }

  translateStatus(status: string) {
    return this.statuses.get(status);
  }
}
